import * as React from 'react';
import { HeaderImage } from './../Models/homeModel';

export interface LayoutProps {
    children?: React.ReactNode;
}

export class HeaderImageComponent extends React.Component<HeaderImage, HeaderImage> {
    
    public componentDidMount() {

    }

    public render() {

        return <section id="mainArea" className="text-center" style={{ backgroundColor: "black" }} >
            { /* start main slider */}
            <div className="flexslider" id="main-slider" >
                <ul className="slides">
                    <li key={this.props.Image} style={{ display: "block" }} >
                        <img src={"Files/" + this.props.PageGroupID + "/" + this.props.Image} alt={this.props.TitleText} title={this.props.TitleText} />
                    </li>
                </ul>
            </div>
            { /* end main slider*/}

        </section>;
    }
   
    
}


// WEBPACK FOOTER //
// ./ClientApp/app/Components/headerImage.tsx